/** Pastille ronde : logo ou initiales. */
import { useEffect, useState } from "react";
import { companyInitials, companyLogoUrl } from "../company/logoUrl";
import type { Company } from "../types";

export function CompanyMark({ company, className = "" }: { company: Company | null; className?: string }) {
  const [broken, setBroken] = useState(false);
  useEffect(() => {
    setBroken(false);
  }, [company?.id, company?.logo_path, company?.updated_at]);
  const name = company?.legal_name || "?";
  const showImg = Boolean(company?.logo_path) && !broken;

  return (
    <span className={`fx-co-mark ${className}`.trim()}>
      {showImg && company ? (
        <img src={companyLogoUrl(company)} alt="" onError={() => setBroken(true)} />
      ) : (
        <span>{companyInitials(name)}</span>
      )}
    </span>
  );
}
